export default [
  {
    path: '/404',
    name: '404',
    meta: {
      title: '404'
    },
    component: () => import(/* webpackChunkName: "404" */ 'src/views/error/404.vue')
  },
  {
    path: '/login',
    name: 'login',
    meta: {
      title: '登录中...'
    },
    component: () => import(/* webpackChunkName: "login" */ 'src/views/login/index.vue')
  },
  {
    path: '/home',
    name: '首页',
    meta: {
      title: '首页',
      // 是否限于内部员工可用
      inside: true
    },
    component: () => import(/* webpackChunkName: "home" */ 'src/views/home/index.vue')
  },
  {
    path: '/outside',
    name: '外部页面',
    meta: {
      title: '首页',
      inside: false
    },
    component: () => import(/* webpackChunkName: "outside" */ 'src/views/outside/index.vue')
  },
  {
    path: '/userInfo',
    name: '用户信息页面',
    meta: {
      title: '用户信息页面',
      inside: true
    },
    component: () => import(/* webpackChunkName: "outside" */ 'src/views/user-info/index.vue')
  },
  {
    path: '/send-message',
    name: '发送小程序卡片',
    meta: {
      title: '发送小程序卡片',
      inside: true
    },
    component: () => import(/* webpackChunkName: "outside" */ 'src/views/send-message/index.vue')
  },
  {
    path: '/group-info',
    name: '群用户信息',
    meta: {
      title: '群用户信息',
      inside: false // :TODO: 设置为 false 以为在 user-info 已经调用了 init 这里不需要
    },
    component: () => import(/* webpackChunkName: "outside" */ 'src/views/group-info/index.vue')
  },
  {
    path: '/single-info/:userId',
    name: '用户信息',
    meta: {
      title: '用户信息',
      inside: false
    },
    component: () => import(/* webpackChunkName: "outside" */ 'src/views/single-info/index.vue')
  },
  {
    path: '/remind-page',
    name: '提醒页面',
    meta: {
      title: '提醒页面',
      inside: false
    },
    component: () => import(/* webpackChunkName: "outside" */ 'src/views/remind-page/index.vue')
  },
  {
    path: '*',
    redirect: '/404'
  }
]
